import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WcIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wc"}/>
}
